import React, {useState} from "react";
import {useLocation} from "react-router-dom";
import CustomDialog from "../../../core/components/ui/CustomDialog";
import {Box, CircularProgress} from "@mui/material";
import CustomDialogLoaderComponent from "../../../core/components/common/custom-dialog-loader.component"
import useBooking from "../hooks/useBooking";
import CustomTypography from "../../../core/components/ui/CustomTypography";
import BookingStatusListDropdownComponent from "../common/booking-status-list-dropdown.component";

const UpdateStatusDialog = (props) => {
    const {open, setOpen, selectedBooking} = props;

    const location = useLocation();
    
    const {isFetchingBookingStatusList, bookingStatusList, getBookingStatusList, isUpdatingBookingStatus, updateBookingStatus} = useBooking();

    const [selectedStatus, setSelectedStatus] = useState(selectedBooking?.status);

    const rbacStorage = JSON.parse(localStorage.getItem("rbac-storage"));
    const storedOrgIdFromRBACForBusiness = rbacStorage?.state?.currentProfile?.orgId || null;
    const orgIdFromUrlForPortEmployee = new URLSearchParams(location.search).get("org_uid");


    const handleStatusChange = (value) => {
        setSelectedStatus(value);
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleUpdateStatus = () => {
        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;

        if (organizationId) {
            const parameters = {
                bookingUID: selectedBooking?.booking_uid,       
                status: selectedStatus,
                orgUID: organizationId
            }

            updateBookingStatus(parameters);
            
        } else {
            const parameters = {
                bookingUID: selectedBooking?.booking_uid,       
                status: selectedStatus,
            }

            updateBookingStatus(parameters);
        }
    }

    const actions = [
        {
            label: "Cancel",
            onClick: (e) => setOpen(false),
            variant: "outlined",
            customStyles: {
                opacity: 1, mr: 1
            }
        },
        {
            label: "Update",
            onClick: (e) => (selectedStatus && selectedStatus !== selectedBooking?.status) ? handleUpdateStatus(e) : null,
            customStyles: {
                opacity: (selectedStatus && selectedStatus !== selectedBooking?.status && !isUpdatingBookingStatus) ? "100%" : "55%",
                cursor: (selectedStatus && selectedStatus !== selectedBooking?.status && !isUpdatingBookingStatus) ? "pointer" : "not-allowed !important",
                visibility: (isUpdatingBookingStatus) ? "hidden" : "visible",
            },
        }
    ]

    const globalSx = {
       //
    }


    return (
        <>
            <CustomDialog
                open={open}
                onClose={(isUpdatingBookingStatus) ? null : handleClose}
                title="Update Status"
                subtitle={"Manage booking status in real-time"}
                hasDividers={true}
                content={
                    <Box>
                        {(isUpdatingBookingStatus) ? 
                            <Box sx={{mb: "80px"}}>
                                <CustomDialogLoaderComponent 
                                    icon={<CircularProgress size={40} sx={{color: "#2196f3"}} />} 
                                    message={"Updating booking status..."}
                                />
                            </Box>
                        : 
                            <>
                                <CustomTypography 
                                    variant="subtitle2"
                                    text={"Status"}
                                    customStyles={{
                                        mb: (selectedStatus) ? 2 : 1
                                    }}
                                />

                                <BookingStatusListDropdownComponent 
                                    value={selectedStatus}
                                    onChange={handleStatusChange}
                                    fullWidth={true}
                                    size={"medium"}
                                    isFetchingBookingStatusList={isFetchingBookingStatusList}
                                    bookingStatusList={bookingStatusList}
                                    getBookingStatusList={getBookingStatusList}
                                /> <br/>
                            </>
                        }
                    </Box>
                }
                actions={!isUpdatingBookingStatus && actions}
                maxWidth={"sm"}
                customStyles={{}}
                globalSx={globalSx}
            />
        </>
    )
}

export default UpdateStatusDialog
